
import { mapMutations } from "vuex";
import BannerContainer from "@/components/child/banner/BannerContainer";
import TagContainer from "@/components/child/tag/TagContainer";
import RecipeContainer from "@/components/child/recipe/RecipeContainer";
import BrowseContainer from "@/components/child/browse/BrowseContainer";
import ArticleChannelContainer from "@/components/child/article/ArticleChannelContainer";
import BloggerRankingChannel from "@/components/child/blogger/BloggerRankingChannel";
import ArticleHotContainer from "@/components/child/article/ArticleHotTravelContainer";
import { getHotArticle } from "@/apis/travel";

export default {
    name: "travel",
    components: {
        BannerContainer,
        TagContainer,
        RecipeContainer,
        BrowseContainer,
        ArticleChannelContainer,
        BloggerRankingChannel,
        ArticleHotContainer
    },
    head() {
        return {
            title: '旅遊-PIXNET痞客邦',
            meta: [
                { hid: 'description', name: 'description', content: '痞客邦有部落客分享的新景點、旅遊懶人包、國外旅遊、IG打卡熱點、親子旅行，1日行程、2天1夜推薦應有盡有。更有飯店推薦、民宿推薦，各路旅遊達人帶你盡情放肆玩。' },
                { hid: 'og:description', name: 'og:description', property: 'og:description', content: '痞客邦有部落客分享的新景點、旅遊懶人包、國外旅遊、IG打卡熱點、親子旅行，1日行程、2天1夜推薦應有盡有。更有飯店推薦、民宿推薦，各路旅遊達人帶你盡情放肆玩。' },
                { hid: 'twitter:description', name: 'twitter:description', property: 'twitter:description', content: '痞客邦有部落客分享的新景點、旅遊懶人包、國外旅遊、IG打卡熱點、親子旅行，1日行程、2天1夜推薦應有盡有。更有飯店推薦、民宿推薦，各路旅遊達人帶你盡情放肆玩。' },
                { hid: 'keywords', name: 'keywords', content: '旅遊，國內旅遊，國外旅遊，熱門景點，旅遊新知，住宿，民宿，機票' },
                { hid: 'og:title', name: 'og:title', property: 'og:title', content: "旅遊-PIXNET痞客邦" },
                { property: 'og:image', property: 'og:image', content: "https://www.pixnet.net/img/public/og/img_travel_og.png" },
                { property: 'og:image:secure_url', property: 'og:image:secure_url', content: "https://www.pixnet.net/img/public/og/img_travel_og.png" },
                { property: 'twitter:image', property: 'twitter:image', content: "https://www.pixnet.net/img/public/og/img_travel_og.png" },
                { property: 'image', name: 'image', itemprop: 'image', content: "https://www.pixnet.net/img/public/og/img_travel_og.png" },
            ],
            link: [
                { rel: 'canonical', href: 'https://www.pixnet.net/channel/travel', key: "canonical" }
            ]
        }
    },
    jsonld() {
        return {
            "@context": " https://schema.org/",
            "@graph": [
                {
                    "@context": "https://schema.org",
                    "@type": "Organization",
                    "url": "https://www.pixnet.net",
                    "logo": "https://www.pixnet.net/img/public/og/img_travel_og.png",
                    "name": "痞客邦",
                    "@id": "https://www.pixnet.net/#organization",
                    "description": "痞客邦有部落客分享的新景點、旅遊懶人包、國外旅遊、IG打卡熱點、親子旅行，1日行程、2天1夜推薦應有盡有。更有飯店推薦、民宿推薦，各路旅遊達人帶你盡情放肆玩。",
                    "address": "",
                    "brand": {
                        "@type": "Brand",
                        "logo": "https://www.pixnet.net/img/public/og/img_travel_og.png"
                    },
                    "sameAs": "https://www.facebook.com/pixnet.net"
                },
                {
                    "@context": "https://schema.org/",
                    "@type": "BreadcrumbList",
                    "itemListElement": [
                        {
                            "@type": "ListItem",
                            "position": 1,
                            "name": "旅遊-PIXNET痞客邦",
                            "item": "https://www.pixnet.net",
                            "description": "痞客邦有部落客分享的新景點、旅遊懶人包、國外旅遊、IG打卡熱點、親子旅行，1日行程、2天1夜推薦應有盡有。更有飯店推薦、民宿推薦，各路旅遊達人帶你盡情放肆玩。",
                            "keywords": "旅遊，國內旅遊，國外旅遊，熱門景點，旅遊新知，住宿，民宿，機票"
                        }
                    ]
                }
            ]
        }
    },
    data() {
        return {
            channel_page_id: 2,
            showAnimation: false,
            tab_list: [
                {
                    title: '國內',
                    id: 1,
                    is_executed_pa: false,
                    is_executed_pa_scroll: false,
                },
                {
                    title: '國外',
                    id: 2,
                    is_executed_pa: false,
                    is_executed_pa_scroll: false,
                }
            ],
            day_hot_article: [],
            day_hot_article_full: [],
            isCallHotArticleApi: false
        }
    },
    computed: {
        is_login() {
            return this.$store.state.login.login_status;
        },
        tab_id() {
            return this.$store.state.channel_tab.tab_id;
        },
        tab_left() {
            return this.$store.state.channel_tab.tab_highlight_style.left;
        },
        tab_width() {
            return this.$store.state.channel_tab.tab_highlight_style.width;
        },
        window_width() {
            return this.$store.state.channel_tab.window_width;
        },
        category_id() {
            if (this.tab_id == 1) {
                return 28
            } else if (this.tab_id == 2) {
                return 29
            }
        },
        article_category_id() {
            if (this.tab_id == 1) {
                return 201
            } else if (this.tab_id == 2) {
                return 202
            }
        },
        pa_page_name() {
            if (this.tab_id == 1) {
                return '旅遊/國內'
            } else if (this.tab_id == 2) {
                return '旅遊/國外'
            }
        },
        tag_search_text() {
            if (this.tab_id == 1) {
                return '國內旅遊'
            } else if (this.tab_id == 2) {
                return '國外旅遊'
            }
        }
    },
    methods: {
        ...mapMutations('channel_tab', ['updateTabId', 'updateWindowWidth']),
        activeTab(id) {
            const vm = this;
            vm.removeScrollEventListener();
            if (vm.tab_id != id) {
                vm.updateTabId(id);
                vm.getHotArticleApi();
            }
            // 為了記錄各 tab 的 PA 有沒有執行過
            let activeTabIndex = vm.tab_list.findIndex((item => item.id === id));
            let isExecutedPa = vm.tab_list[activeTabIndex].is_executed_pa;
            let isExecutedPaScroll = vm.tab_list[activeTabIndex].is_executed_pa_scroll;
            if (!isExecutedPa) {
                vm.paFunction();
                vm.tab_list[activeTabIndex].is_executed_pa = true
            }
            if (!isExecutedPaScroll) {
                vm.addScrollEventListener()
            }
        },
        setShowAnimation() {
            const vm = this;
            setTimeout(() => {
                vm.showAnimation = true;
            }, 500)
        },
        setWindowWidth() {
            const vm = this;
            vm.updateWindowWidth(window.innerWidth)
        },
        executeWhenResize(e) {
            const vm = this;
            vm.setWindowWidth();
        },
        paFunction() {
            window._piq.push(['trackEvent', 'rs2022::十大頻道::' + this.pa_page_name, 'imps::頁面::page::user_action', '', '']);
        },
        paScrollFunction() {
            addEventListener("scroll", () => {
                window._piq.push(['trackEvent', 'rs2022::十大頻道::' + this.pa_page_name, 'scroll::頁面::page::user_action', '', '']);
            }, { once: true });
        },
        addScrollEventListener() {
            window.addEventListener('scroll', this.paScrollFunction, { once: true });
        },
        removeScrollEventListener() {
            window.removeEventListener('scroll', this.paScrollFunction);
        },
        gtag() {
            window.dataLayer.push(arguments);
        },
        activeGaPage() {
            this.gtag('config', 'G-RPGK0ML6QM', {
                'channel_category': '旅遊'
            });
            this.gtag('config', 'G-45SMZ66RLZ', {
                'channel_category': '旅遊'
            });
            this.gtag('event', 'page_view', {
                page_title: '旅遊-PIXNET痞客邦',
            });
        },
        activeMcPage() {
            (function (c, l, a, r, i, t, y) {
                c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments) };
                t = l.createElement(r); t.async = 1; t.src = "https://www.clarity.ms/tag/" + i;
                y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
            })(window, document, "clarity", "script", "kbvat69or6");
        },
        getHotArticleApi() {
            const vm = this;
            const tmpId = vm.tab_id == 1 ? 28 : 29;
            vm.isCallHotArticleApi = false;
            vm.day_hot_article = [];
            vm.day_hot_article_full = [];
            getHotArticle(tmpId).then((res) => {
                const tmpResData = res.data;
                if (tmpResData.success) {
                    const tmpData = tmpResData.data;
                    const tmpArticle = tmpData.articles;
                    vm.day_hot_article = tmpArticle.sort((a, b) => a.date.replace(/\//g, '') - b.date.replace(/\//g, '')).reverse().slice(0, 6);
                    vm.day_hot_article_full = tmpArticle.sort((a, b) => a.date.replace(/\//g, '') - b.date.replace(/\//g, '')).reverse();
                }
            }).catch(() => {
                console.log("網路傳輸錯誤");
            }).finally(() => {
                vm.isCallHotArticleApi = true;
            });
        }
    },
    mounted() {
        const vm = this;
        window.dataLayer = window.dataLayer || [];
        vm.activeGaPage();
        vm.activeMcPage();
        window.addEventListener("resize", vm.executeWhenResize);
        vm.setShowAnimation();
        vm.setWindowWidth();
        vm.activeTab(vm.tab_id);
        vm.paScrollFunction();
        vm.getHotArticleApi();
    },
    async fetch() {
        const item = { sort: 'hot', type: 'group', pre_page: 10, id: this.channel_page_id, ver: 2 }
        await this.$store.dispatch("article/getDayHotArticle", item);
    }
}
